import classnames from 'classnames';
import { number, string } from 'prop-types';
import React from 'react';

import ShortCurrencyFormat from '../../generic/ShortCurrencyFormat';

function OpenAmount({ description, value, className }) {
  return (
    <span className={classnames('p-1 text-muted', className)}>
      {description}: <ShortCurrencyFormat value={value} />
    </span>
  );
}

OpenAmount.propTypes = {
  description: string.isRequired,
  value: number.isRequired,
  className: string,
};

OpenAmount.defaultProps = {
  className: '',
};

export default OpenAmount;
